export interface Panel {
    id: number,
    name: string,
    description: string,
    image: any
}

export interface InfoCardType {
    id: number | string,
    date: string,
    heading: string,
    description: string,
    link: string,
    image?: any
}

interface newsSections{
    heading?:string,
    body:string,
}


export interface EventDataTypes extends InfoCardType{
    headerImage?:any,
    sections?:Array<newsSections>
}

export interface NewsDataTypes extends InfoCardType{
    author:string;
    isPopular:boolean,
    headerImage?:any,
    body:any
//     sections?:Array<newsSections>
}

export enum sectionId {
    SCIENCE_TECHNOLOGY = "SECTION_SCIENCE_TECHNOLOGY",
    AGRICULTURE_FISHING = "SECTION_AGRICULTURE_FISHING",
    BUSINESS_SERVICES = "SECTION_BUSINESS_SERVICES",
    CONSTRUCTION = "SECTION_CONSTRUCTION",
    FOOD_RESTAURANTS = "SECTION_FOOD_RESTAURANTS",
    HOSPITALITY_TOURISM_TRANSPORT = "SECTION_HOSPITALITY_TOURISM_TRANSPORT",
    MANUFACTURERS = "SECTION_MANUFACTURERS",
    HEALTH_FITNESS = "SECTION_HEALTH_FITNESS",
    FASHION_DESIGN = "SECTION_FASHION_DESIGN",
    ENTERTAINMENT = "SECTION_ENTERTAINMENT",

}

export interface IndustryDataType {
    name: string,
    route: string,
    isActive: boolean,
    enabled?:boolean,
    id: sectionId,
    heading: string;
    description: string;
    paragraph?: string | any
    paragraphTwo?: string | any
    image?: any;
    cards: Array<{
        image?: any,
        heading?: string,
        description?: string
    }>;
}

export interface SectionsProps {
    changeStep:(direction: string) => void
    setNewBusinessInfo: React.Dispatch<React.SetStateAction<AddBusinessType>>
    newBusinessInfo: AddBusinessType
    submitForm?:()=>void
    setSectionName?:any
}


export interface AddBusinessType{
    id?:number|string,
    is_approved:number|string|boolean,
    member_id:string|number
    date_approved?:string|Date
    membership_level:string;

    information: {
        title: string,
        name: string,
        address: string,
        contact: string,
        email: string,
        website: string,
    },

    details: {
        is_registered: string|boolean,
        registration_number: string,
        tax_registration_number: string,
        is_new: string,
        business_type: string,
    },

    category: {
        service_type: string,
        category: string,
        years: number | undefined,
        target_market: string,
        number_of_employees:string
    }

    products_services:Array<
            {
                type:string,
                name:string,
                description:string
            }
        >


    required_assistance:{
        assistance: Array<string>,
        expos_assistance:string
    }

    expectation_of_sbaj:string

    other_information:{
        committee_service:string,
        how_did_you_find_us:string,
        list_in_directory: string,
        other_employment:string,
        specify:string,
        area_of_expertise:string
    }

    payment:any
}

export interface EventsType {
    id: number,
    date: string,
    time?:string,
    venue?: string,
    address?: string,
    image: string,
    title: string,
    description: string,
    category: Array<string>
}

export enum BusinessLevels{
    "MICRO_BUSINESS"="Micro Business",
    "SMALL_BUSINESS"="Small Business",
    "MEDIUM_BUSINESS_ENTERPRISE"="Medium Business Enterprise",
    "ASSOCIATED_COMPANY"="Associated Company",
}